export default __webpack_public_path__ + "static/media/star.0fd28a6e.png";